import React, { Component } from 'react';
import Api from '../../api';
import VerticalBarChart from './verticalBarChart';
import { Spinner } from '../spinner';
import { getProp } from '../../utilities';
import './electionWidget.css';
import HorizontalBarChart from './horizontalBarChart';

const colorRange = [
  '#8224e3', // Slovenská ľudová strana Andreja Hlinku, id: 1
  '#D93DD1', // dobra volba, id: 2
  '#74CE39', // sas, id: 3
  '#3971CE', //sme rodina, id: 4
  '#774977', // Slovenské Hnutie Obrody, id: 5
  '#FFAA00', // za ludi, id: 6
  '#775577', // MÁME TOHO DOSŤ, id: 7
  '#789101', // Hlas pravice, id:8
  '#B080B0', // Slovenská národná strana, id: 9
  '#792777', // Demokratická strana, id: 10
  '#5B8F29', // OBYČAJNÍ ĽUDIA a nezávislé osobnosti (OĽANO), id: 11
  '#59D0F7', // Koalícia Progresívne Slovensko a SPOLU - občianska demokracia, id
  '#737777', //STAROSTOVIA A NEZÁVISLÍ KANDIDÁTI, id: 13
  '#745777', //99 % - občiansky hlas, id: 14
  '#0C3E95', //Kresťanskodemokratické hnutie, id: 15
  '#727777', //Slovenská liga|Slovenská liga, id: 16
  '#4C4C4C', //VLASŤ id: 17,
  '#FD6A37', //MOST - HÍD, id: 18
  '#CD2528', //SMER, id: 19
  '#777797', //SOLIDARITA - Hnutie pracujúcej chudoby, id: 20
  '#777779', //HLAS ĽUDU, id: 21,
  '#206E21', //Magyar Közösségi Összefogás - Maďarská komunitná spolupatričnosť, id: 22,
  '#778777', //Práca slovenského národa, id: 23,
  '#313131', //Kotlebovci - Ľudová strana Naše Slovensko,
  '#123456', // Socialisti.sk, id: 25,
  '#909090', // mimo paralmanetu -> maju menej ako 5%
];

class ElectionWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isFetching: false,
      selectedValue: props.id,
    };

    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData(this.props.type, this.props.id);
    this.fetchInterval = setInterval(() => {
      this.fetchData(this.props.type, this.props.id);
    }, 120000);
  }

  componentWillUnmount() {
    clearInterval(this.fetchInterval);
  }

  fetchData(type, id) {
    const url = id ? `${type}/${id}` : type;

    this.setState(
      {
        isFetching: true,
      },
      async () => {
        try {
          const data = await Api.get(`/election/${url}`);
          this.setState({
            data,
            isFetching: false,
          });
        } catch (e) {
          this.setState({
            error: getProp(e, 'message', ''),
            isFetching: false,
            data: {},
          });
        }
      },
    );
  }

  render() {
    const { header, staticData, id, hideUpdateTime } = this.props;
    const { data, selectedValue, error } = this.state;

    return (
      <div className="election-widget">
        <Spinner show={this.state.isFetching && Object.keys(data).length === 0}>
          {getProp(error, 'message', '') === 'Not Found' ? (
            <h2>Volebné dáta momentálne nie sú dostupné!</h2>
          ) : (
            <div>
              <div className="election-widget-header-wrapper">
                <h2>{header}</h2>
                {Array.isArray(staticData) && staticData.length && (
                  <select
                    className="election-widget-select"
                    onChange={e => {
                      this.setState({ selectedValue: e.target.value });
                      this.fetchData(this.props.type, e.target.value);
                    }}
                    value={selectedValue}
                  >
                    {staticData.map(option => (
                      <option
                        key={option.id}
                        value={option.id ? option.id : ''}
                        selected={id ? id : true}
                      >
                        {option.name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              {this.state.data.cd_submitted_count ? (
                <div className="flex">
                  <VerticalBarChart
                    data={getProp(data, 'ps_data', [])}
                    colorRange={colorRange}
                    className="election-vertical-chart"
                  />
                  <HorizontalBarChart
                    data={getProp(data, 'ps_data', [])}
                    colorRange={colorRange}
                    className="election-horizontal-chart"
                  />

                  <div className="chart-meta-data">
                    <div>
                      <b>Celkový počet okrskov</b>:{' '}
                      {getProp(data, 'cd_count', 0)}
                    </div>
                    <div>
                      <b>Počet sčítanych okrskov</b>:{' '}
                      {getProp(data, 'cd_submitted_count', 0)}
                    </div>
                    <div>
                      <b>Sčítanosť</b>: {getProp(data, 'cd_submitted_pct', 0)}%
                    </div>
                    {!hideUpdateTime && (
                      <div>
                        <b>Aktualizované</b>: {getProp(data, 'updated')}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div>
                  Sčítavanie hlasov pre <b>{getProp(data, 'name', '')}</b> ešte
                  nezačalo
                </div>
              )}
            </div>
          )}
        </Spinner>
      </div>
    );
  }
}

export default ElectionWidget;



// WEBPACK FOOTER //
// ./src/ui/src/component/electionWidget/electionWidget.js